import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";

import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../../components/theme/label/ShLabel";
// import Text from "../../../../../components/theme/text/Text";

import { useEffect, useState } from "react";
import OrdersCard from "../../../../../components/global/cards/orders/OrdersCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useBulkCancelOrdersMutation, useBulkSplitBackordersMutation, useGetOrdersQuery } from "../../../../../newapi/order/ordersSlice";

import { useRef } from "react";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import { getOrderStateData } from "../../../../../utils/labelColorText";
import { general_states } from '../../../../../utils/staticEnums';
import { ORDER_FILTER_KEYS, BACKORDER_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import MpAddOrder from "../../../../../components/global/ModalsProgression/MpAddOrder/MpAddOrder";
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import ShDataGridSelectedActions from '../../../../../components/theme/datagrid2/ShDataGridSelectedActions';
import DropdownButton from '../../../../../components/theme/buttons/DropdownButton';
import ClearIcon from '@mui/icons-material/Clear';
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from '../../../../../utils/toasts';
import MLoader from '../../../../../components/global/Modals/MLoader';
import MConfirmation from '../../../../../components/global/Modals/MConfirmation';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasCreatePermission ?
        <ButtonGroup version={2}>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_order')}
            </Shbutton>
        </ButtonGroup> : <></>
}

const OutboundBackorderView = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            BACKORDER_FILTER_KEYS.STREAM,
            BACKORDER_FILTER_KEYS.SHIPPER,
            BACKORDER_FILTER_KEYS.PRODUCT,
            ...(isFulfilment ? [BACKORDER_FILTER_KEYS.RELATION] : []),
            BACKORDER_FILTER_KEYS.B2B_ORDERS,
        ],
    };

    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config,setConfig] = useState({[ORDER_FILTER_KEYS.STATE.backend_key]:[general_states.BACKORDERED]});

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );

    const hasModifyPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.PICKINGJOB_MANAGE])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [isUpdating, setIsUpdating] = useState(false);
    
    const [cancelOrderModalOpen,setCancelOrderModalOpen] = useState(false);
    const cancelOrderModal = {
        open: cancelOrderModalOpen,
        setOpen: setCancelOrderModalOpen,
    }

    const [bulkCancelOrders, { isLoading: updateLoading }] = useBulkCancelOrdersMutation();

    const handleCancelOrders = async() => {
        if (selectedItems.length === 0) return;

        if(updateLoading) return;
        setIsUpdating(true);

        try {
            const response = await bulkCancelOrders({
                orderIds: selectedItems
            }).unwrap();

            setSelectedItems([]); // Clear selection after successful update
            showToastMessageUpdateRequest(t, response);
        } catch (error) {
            console.error('Failed to snooze orders:', error);
            showToastMessageRequestError(t("update_failed"), t, error);
        } finally {
            setIsUpdating(false);
        }
    }

    const [splitBackorderModalOpen, setSplitBackorderModalOpen] = useState(false);
    const splitBackorderModal = {
        open: splitBackorderModalOpen,
        setOpen: setSplitBackorderModalOpen,
    }

    const [isSplitting, setIsSplitting] = useState(false);
    const [bulkSplitBackorders, { isLoading: splitLoading }] = useBulkSplitBackordersMutation();

    // Splits the backordered quantities off the selected orders. Orders that are fully in
    // backorder are left untouched by the backend, those come back as skipped.
    const handleSplitBackorders = async() => {
        if (selectedItems.length === 0) return;

        if(splitLoading) return;
        setIsSplitting(true);

        try {
            const response = await bulkSplitBackorders({
                orderIds: selectedItems
            }).unwrap();

            setSelectedItems([]);

            // The response counts how many orders were split, skipped and failed
            let toastType = "success";
            if (response.failedCount > 0) {
                toastType = "error";
            } else if (response.splitCount === 0) {
                toastType = "warning";
            }
            showToastMessage(toastType, response.message);
        } catch (error) {
            showToastMessageRequestError(t("update_failed"), t, error);
        } finally {
            setIsSplitting(false);
        }
    }

    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (locSelectedItems) => {
        setSelectedItems(locSelectedItems);
    };

    const [defaultTab, setDefaultTab] = useState(null);
    const handleClose = (response) => {
        setAddModalOpen(false);
        const newOrderState = response?.data?.state ?? response?.state;
        const newOrderId = response?.data?.id ?? response?.id;
        if (newOrderState === general_states.ACTION_REQUIRED_CUSTOMER && newOrderId) {
            if (!spLoading) setSpLoading(true);
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId;
            setDefaultTab(2);
            setIsExtended(true);
        }
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);
    
    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setDefaultTab(null);
        setIsExtended(true);
    };

    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                minWidth:"100%",
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                position:"relative",
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden",
                                gap:2,

                            }}
                        >
                            <Text noBreak>{params.row.barcode}</Text>
                            {params.row.remark &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("remark")}</Text>
                                            <Text>{params.row.remark}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <CommentOutlinedIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                            {params.row.isB2B &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("b2b")}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <BusinessIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "deliveryName", headerName: t("delivery_name"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.deliveryName
            }
        },
        {field: "webshopreference", headerName: t("webshopreference"),flex:2, filter: BACKORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.relation?.name} - ${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {
            field: "date_planned", 
            headerName: t("date_planned_shipment"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {

                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
                let planned = new Date(params.row.date_planned);
                let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
                let latestHandoverDateTime = params.row.latestHandoverDateTime ? new Date(params.row.latestHandoverDateTime) : null;

                if(sent) {
                    // when sent is filled and is equal to planned: green
                    if(sent.getTime() === planned.getTime()) {
                        labelcolor = "green";
                    }
                    // when sent is filled but later than planned: orange
                    else if(sent.getTime() > planned.getTime()) {
                        labelcolor = "orange";
                    }
                }
                else {
                    // When sent is not filled and planned >= now: blue
                    if(planned.setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    } else if(latestHandoverDateTime && (new Date().setHours(0,0,0,0) < latestHandoverDateTime)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    // When sent is not filled and planned < now: red
                    } else if(planned.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                        labelcolor = "red";
                    }
                }
              
                return (
                    <SHQuickAction
                        component={ params.row.latestHandoverDateTime !== null ?
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("handover_date")}</Text>
                                <Text>
                                    { new Date(params.row.latestHandoverDateTime).toLocaleDateString(i18n.language)}&nbsp;
                                    <b>
                                    {new Date(params.row.latestHandoverDateTime).toLocaleTimeString(i18n.language, {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                    </b>
                                </Text>
                            </Box>
                            : 
                            null
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup={false}
                                onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
                                onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
                                onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
                                sx={{
                                    width:1,
                                }}
                            >
                                <ShLabel clickable size={32} fitted variant={labelcolor} palette="normal">
                                    {!sent && planned.toLocaleDateString(i18n.language)}
                                    {sent && sent.toLocaleDateString(i18n.language)}
                                </ShLabel>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1,
            sortable:false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amountOfLines
        }},
        {field: "stream", headerName: t("stream"),flex:1, filter: BACKORDER_FILTER_KEYS.STREAM,
            filter: ORDER_FILTER_KEYS.STREAM,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.stream?.shortName
            }
        },
        {field: "shipper", headerName: t("shipper_name"),flex:2, filter: BACKORDER_FILTER_KEYS.SHIPPER,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return `${params.row.shipper?.name ?? ""} - ${params.row.shipperprofile?.name ?? ""}`
        }},
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                const { labelcolor, labeltext } = getOrderStateData(params.row.state, theme, false, params.row.snoozeWhenAvailable);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <Text>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </Text>
                );
                }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard onClick={() => getOrderDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                pollingInterval={true}
                content={useGetOrdersQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t('backorder') }
                gridOptions={gridOptions}
                sortModel={{field: columns[8].field,type:"DESC"}}
                columns={columns}
                onRowClick={getOrderDetails}
                selectable
                setSelected={onSelected}
                keepSelectedAlive
                keepNonExistentRowsSelected
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        {hasModifyPrivilege && (
                            <DropdownButton
                                onClick={() => cancelOrderModal.setOpen(true)}
                                icon={<ClearIcon/>}
                                text={t("cancel_orders")}
                            />
                        )}
                        {hasCreatePermission && (
                            <DropdownButton
                                onClick={() => splitBackorderModal.setOpen(true)}
                                icon={<SplitscreenIcon/>}
                                text={t("split_backorder_lines")}
                            />
                        )}
                    </ShDataGridSelectedActions>
                }
            >
                    
            </ShDataGrid2>
            
            {spLoading &&
                <SpOrderDetails
                    defaultTab={defaultTab}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                    // data={orderData}
                /> 
            }
            <MpAddOrder onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />

          <MLoader
            open={isUpdating}
            message={t('cancelling_orders')}
          />

            <MLoader
                open={isSplitting}
                message={t('splitting_backorder_lines')}
            />

            <MConfirmation
                open={cancelOrderModal.open}
                handleClose={() => setCancelOrderModalOpen(false)}
                title={t("cancel_orders")}
                content={t("cancel_orders_text")}
                confirm={() => handleCancelOrders()}
            />

            <MConfirmation
                open={splitBackorderModal.open}
                handleClose={() => setSplitBackorderModalOpen(false)}
                title={t("split_backorder_lines")}
                subtitle={t("mc_bulk_split_backorder_subtitle")}
                content={t("mc_bulk_split_backorder_content")}
                confirm={() => handleSplitBackorders()}
            />
        </Box>
    );
}
export default OutboundBackorderView;